import ActionType from  '../actions/ActionType';
import {Time, Config} from '../util';

const PAGE_SIZE = 1000;  // 한 페이지에 보여줄 게시물의 개수


const initState = {
  sessionTimeFlag: false,
  selectedMenu: '',
  selectedDate: Time.getAddDate(Time.getToday(), -1),
  channelList: [],
  videoItem: {
    video1: {},
    video2: {},
    video3: {},
    video4: {}
  },
  searchCondition: {
    pageSize: PAGE_SIZE,
    totalCount: 0,
    chs: '',
    keyword: ''
  },
  logCondition: {
    pageSize: PAGE_SIZE,
    totalCount: 0,
    chs: '',
    keyword: ''
  },
  markInInfo: {
    date: '',
    chName: '',
    fileName: '',
    tc: '',
  },
  markOutInfo: {
    date: '',
    chName: '',
    fileName: '',
    tc: '',
  },
  detailInfo: '',
  activeChannelListIndex: 0,
  videoFlag: false,
  modalFlag: false,
  detailFlag: false,
  userFlag: false,
  userInfoType: '',
  
  activeVideo: '',
  activeVideoType: 'Item',

  noticeFlag: false,
  noticeState: '',
  noticeContent: '',
}


const reducer = (state = initState, action) => {
  if(!state.selectedMenu) state.selectedMenu = Config.isMode;
  switch(action.type) {
    case ActionType.SELECT_NAV_MENU:
      return selectNavMenu(state, action);
    case ActionType.SELECT_DATE:
      return selectDate(state, action);
    case ActionType.SET_CHANNEL_LIST:
      return setChannelList(state, action);
    case ActionType.CREATE_VIDEO:
      return createVideo(state, action);
    case ActionType.UPDATE_SEARCH_CONDITION:
      return updateSearchCondition(state, action);
    case ActionType.UPDATE_CHANNEL_LIST_INDEX:
      return updateActiveChannelListIndex(state, action);
    case ActionType.SHOW_VIDEO:
      return showVideoFlag(state,action);
    case ActionType.SHOW_MODAL:
      return showModalFlag(state, action);
    case ActionType.SHOW_DETAIL:
        return showDetailFlag(state, action);
    case ActionType.SHOW_USER:
        return showUserFlag(state, action);
    case ActionType.SET_VIDEO_SOUND_ITEM:
      return setVideoSoundItem(state,action);
    case ActionType.SET_VIDEO_TYPE:
      return setVideoType(state,action);
    case ActionType.UPDATE_LOG_CONDITION:
      return updateLogCondition(state, action);
    case ActionType.SET_MARKIN_TC:
        return setMarkInTC(state, action);
      case ActionType.SET_MARKOUT_TC:
      return setMarkOutTC(state, action);
    case ActionType.SET_NOTICE:
      return setNotice(state, action);
    default:
      return state;
  }
}

const selectNavMenu = (state, action) => {
  return Object.assign({}, state, action)
}

const selectDate = (state, action) => {
  return Object.assign({}, state, action)
}

const setChannelList = (state, action) => {
  return Object.assign({}, state, action)
}

const createVideo = (state, action) => {
  const videoResult = Object.assign({}, state.videoItem, action.videoItem);
  delete videoResult.type;
  const result = Object.assign({}, state, {videoItem: videoResult});
  return result;
}

const updateSearchCondition = (state, action) => {
  const searchCondition = Object.assign({}, state.searchCondition, action.searchCondition);
  const result = Object.assign({}, state, {searchCondition});
  return result;
}

const updateLogCondition = (state, action) => {
  const logCondition = Object.assign({}, state.logCondition, action.logCondition);
  const result = Object.assign({}, state, {logCondition});
  return result;
}

const updateActiveChannelListIndex = (state, action) => {
  return Object.assign({}, state, action);
}

const showVideoFlag = (state, action) => {
  return Object.assign({}, state, action)
}

const showModalFlag = (state, action) => {
  return Object.assign({}, state, action)
}

const showDetailFlag = (state, action) => {
  return Object.assign({}, state, {
    detailFlag: action.detailFlag,
    detailInfo: action.detailInfo
  })
}

const showUserFlag = (state, action) => {
  return Object.assign({}, state, action)
}

const setVideoSoundItem = (state, action) => {
  return Object.assign({}, state, action);
}
const setVideoType = (state, action) => {
  return Object.assign({}, state, action);
}

const setMarkInTC =(state, action) => {
  const markInInfo = Object.assign({}, state.markInInfo, action.markInInfo);
  return Object.assign({}, state, {markInInfo});
}
const setMarkOutTC =(state, action) => {
  const markOutInfo = Object.assign({}, state.markOutInfo, action.markOutInfo);
  return Object.assign({}, state,  {markOutInfo});
}

const setNotice = (state, action) => {
  return Object.assign({}, state, {
    noticeFlag: action.flag,
    noticeState: action.state,
    noticeContent: action.content
  })
}
export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js